import { createFileRoute } from '@tanstack/react-router';

import { AdminDashboard } from '@/features/dashboard/AdminDashboard';

export const Route = createFileRoute('/_authenticated/dashboard/')({
  component: AdminDashboard,
});
